module.exports = __webpack_public_path__ + "img/list-next.df0de6f6.svg";